const constantUserType = {
  Owner: 'owner',
  Admin: 'admin',
  Developer: 'developer',
  User: 'user',
};

const constantAdvertiserType = {
  advertiser: '광고주',
  agency: '대행사',
  internal: '내부광고',
};

const constantMediaType = {
  t: 'T 아카데미',
  app: 'APP',
};

const constantMediaType2 = {
  app: 'APP',
  client: 'CLIENT',
};

const constantCampainStatus = {
  ing: '진행중',
  book: '예약대기',
  done: '종료',
};

export {
  constantUserType,
  constantAdvertiserType,
  constantMediaType,
  constantMediaType2,
  constantCampainStatus,
};
